import { useEffect, useMemo, useState } from 'react';
import { fetchGraph, type GraphNode, type KnowledgeGraph } from '../api/knowledge';
import { GraphView, type GraphFilters } from '../components/graph/GraphView';
import { GraphFiltersBar } from '../components/graph/GraphFilters';
import { NodeDetailPanel } from '../components/graph/NodeDetailPanel';
import './GraphPage.css';

export function GraphPage() {
  const [graph, setGraph] = useState<KnowledgeGraph | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<GraphFilters>({
    mode: 'all',
    minQuality: 0,
    edgeTypes: new Set(),
  });
  const [selected, setSelected] = useState<GraphNode | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchGraph()
      .then((data) => {
        if (!cancelled) setGraph(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : String(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const body = useMemo(() => {
    if (loading) return <div className="graph-page__status">Loading graph...</div>;
    if (error) return <div className="graph-page__status graph-page__status--error">{error}</div>;
    if (!graph) return <div className="graph-page__status">No graph data.</div>;
    return <GraphView graph={graph} filters={filters} onNodeSelect={setSelected} />;
  }, [loading, error, graph, filters]);

  return (
    <div className="graph-page">
      <header className="graph-page__header">
        <div className="graph-page__title">Knowledge Graph</div>
        <GraphFiltersBar value={filters} onChange={setFilters} />
      </header>
      <div className="graph-page__body">{body}</div>
      {selected && <NodeDetailPanel nodeId={selected.id} onClose={() => setSelected(null)} />}
    </div>
  );
}
